{
  "property_type": "Are you looking for an Apartment, Villa, or Independent House?",
  "city": "Which city are you interested in?",
  "city_or_locality": "Which city or locality are you looking in?",
  "bedrooms": "How many bedrooms (BHK) are you looking for?",
  "carpet_area": "What carpet area (in sqft) are you looking for?",
  "plot_size": "What plot size are you looking for?",
  "budget": "What's your budget range?",
  "generic": "Could you please specify the {{field}}?",
  "_generic_follow_up": "Could you provide more details about what you're looking for?"
}
